module.exports = __webpack_public_path__ + "93069451805ae330fe4d047dede8c922.svg";